module.exports = __webpack_public_path__ + "static/img/effective.e73d1b9c.png";